<script setup lang="ts">
import { ref } from "vue";
import OT from "@opentok/client";
import { getNowInSeconds } from "@/Utils/Date";

export interface DeviceSelectorProps {
  devices: (OT.Device | OT.AudioOutputDevice)[];
  selected?: OT.Device | OT.AudioOutputDevice;
}

const props = defineProps<DeviceSelectorProps>();
const emit = defineEmits<{
  (e: "select", value: OT.AudioOutputDevice): void;
}>();

const wrapperRef = ref<HTMLDivElement | null>(null);

const handleSelect = (device: OT.Device | OT.AudioOutputDevice) => {
  emit("select", device);
};
</script>

<template>
  <div ref="wrapperRef" class="device_selector">
    <div
      v-for="device in props.devices"
      :key="`device-${device.deviceId as string}-${getNowInSeconds()}`"
      class="device_selector__item"
      :class="{
        'device_selector__item--selected': device.deviceId === props.selected?.deviceId,
      }"
      @click="handleSelect(device)"
    >
      {{ device.label }}
    </div>
  </div>
</template>

<style scoped lang="scss">
.device_selector {
  @include colors.bg(background, alt);
  @include radius(s);

  overflow: hidden;

  &__item {
    @include sp.padding(false, 4);
    @include text.general(low, m);

    text-align: left;
    cursor: pointer;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;

    &:hover {
      @include colors.bg(content, low-solid);
    }

    &--selected {
      font-weight: bold;
    }
  }
}
</style>
